module.exports = __webpack_public_path__ + "static/media/styx.e3cca9af.jpeg";